__turbopack_context__.v({
  "noteCounter": "NoteCounter-module__EHwTyq__noteCounter",
  "noteCounterCount": "NoteCounter-module__EHwTyq__noteCounterCount",
});
